module.exports = __webpack_public_path__ + "static/img/wance.bfcb90b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wance.jpg
// module id = t2OE
// module chunks = 5